/**
 * JD1 Works Retail OS R9.3
 * Reliable mobile visual-menu disclosure.
 *
 * Replaces nested <details> for the visual category rows. Safari can keep
 * the visual details box at summary height while wrapped chips paint outside
 * it. A real button + hidden panel keeps every option in normal document flow.
 */
class JD1MobileVisualMenu extends HTMLElement {
  connectedCallback() {
    if (this.dataset.jd1Ready === 'true') return;

    this.dataset.jd1Ready = 'true';
    this.addEventListener('click', this.#onClick);

    const toggles = this.querySelectorAll('[data-jd1-visual-toggle]');
    toggles.forEach((toggle) => {
      const shouldOpen = toggle.getAttribute('aria-expanded') === 'true';
      this.#setState(toggle, shouldOpen, false);
    });
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
    delete this.dataset.jd1Ready;
  }

  #onClick = (event) => {
    const toggle = event.target.closest('[data-jd1-visual-toggle]');
    if (!(toggle instanceof HTMLButtonElement) || !this.contains(toggle)) return;

    const nextOpen = toggle.getAttribute('aria-expanded') !== 'true';

    if (nextOpen) {
      this.querySelectorAll('[data-jd1-visual-toggle][aria-expanded="true"]').forEach((otherToggle) => {
        if (otherToggle !== toggle) this.#setState(otherToggle, false);
      });
    }

    this.#setState(toggle, nextOpen);
  };

  #setState(toggle, open, moveFocus = false) {
    const panelId = toggle.getAttribute('aria-controls');
    if (!panelId) return;

    const panel = this.querySelector(`#${CSS.escape(panelId)}`);
    if (!(panel instanceof HTMLElement)) return;

    toggle.setAttribute('aria-expanded', String(open));
    panel.hidden = !open;

    const item = toggle.closest('.menu-drawer__list-item--jd1-visual');
    item?.classList.toggle('is-open', open);

    if (moveFocus && !open) toggle.focus();
  }
}

if (!customElements.get('jd1-mobile-visual-menu')) {
  customElements.define('jd1-mobile-visual-menu', JD1MobileVisualMenu);
}